class Trustpilot extends HTMLElement {
    constructor() {
        super();

        this.generateUniqueId = () => {
            const array = new Uint32Array(1);
            window.crypto.getRandomValues(array);
            return 'tp-' + array[0];
        }
        this.handleMessage = (event) => {
            const { loadTrustPilot, props } = event.data;
            if (loadTrustPilot) {
                // console.log('message', { loadTrustPilot, props })

                // Check if the script already exists
                const scriptSrc = "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
                const isScriptAlreadyExist = !!document.head.querySelector(`script[src="${scriptSrc}"]`)
                if (!isScriptAlreadyExist) {
                    // console.log('isScriptAlreadyExist', isScriptAlreadyExist)

                    const script = document.createElement("script");
                    script.src = scriptSrc;
                    script.setAttribute('async', true);
                    document.head.appendChild(script);
                }

                const { locale, microStar } = props
                const businessDataId = '4a2f88420000640005044b87'
                const uniqueId = this.generateUniqueId()
                // console.log('uniqueId', uniqueId)

                if (microStar) {
                    this.innerHTML = `<div id=${uniqueId} class="trustpilot-widget" data-locale="${locale}" data-template-id="5419b732fbfb950b10de65e5" data-businessunit-id="${businessDataId}" data-style-height="24px" data-style-width="100%" data-tags="SelectedReview"><a href="https://www.trustpilot.com/review/www.wix.com" target="_blank" rel="noopener">Trustpilot</a></div>`;
                } else {
                    this.innerHTML = `<div id=${uniqueId} class="trustpilot-widget" data-locale="${locale}" data-template-id="5406e65db0d04a09e042d5fc" data-businessunit-id="${businessDataId}" data-style-height="34px" data-style-width="100%" data-theme="light" style-font-size="26px"><a href="https://ca.trustpilot.com/review/www.wix.com" target="_blank" rel="noopener">Trustpilot</a></div>`;
                }
                window.removeEventListener("message", this.handleMessage)
            }
        }
        window.addEventListener("message", this.handleMessage)
    }
    connectedCallback() {
        // console.log('connectedCallback')
    }
    // disconnectedCallback() {
    //     console.log('disconnectedCallback')
    // }

    attributeChangedCallback(name, oldValue, newValue) {}
}

customElements.define('trust-pilot', Trustpilot);